"use client";
import React from "react";

export default function Dialog({
  children,
  open,
  className,
}: {
  children: React.ReactNode;
  open?: boolean;
  className?: string;
}) {
  const closeModal = () => {
    setModal({ ...modal, onopen: false });
  };

  const [modal, setModal] = React.useState({
    onopen: false,
    onclose: closeModal,
    title: "User Login",
  });

  

  return (
    <React.Fragment>
      {open && <div className={className}>{children}</div>}
    </React.Fragment>
  );
}
